var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"id-container"},[(_vm.step === 1)?_c('div',{staticClass:"read-preview"},[_c('readCard',{on:{"get-user-data":_vm.getUserData}})],1):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('recruit',{attrs:{"user-data":_vm.userData,"studentType":_vm.extraParams.studentType,"id":_vm.studentId,"showTestResult":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }